<template>
  <div class="lw-user-info">
    <div class="login-info">
      <!--        trigger="click"-->
      <el-dropdown @visible-change="visibleChange" @command="handleCommand">
        <div class="el-dropdown-link">
          <el-image :src="imgSrc" :key="imgSrc" alt v-if="!isMobile"></el-image>
          <div class="user-info">
            <div class="user-info-name-layout">
              <span class="el-dropdown-link-name">{{ name }}同学</span>
              <div class="down-icon">
                <span v-if="downSelect" class="iconfont lwicon-shouqi up-selete"></span>
                <span v-else class="iconfont lwicon-shouqi down-selete"></span>
              </div>
            </div>
            <!--            {{school.length>9?school.substring(0,9)+'...':school}}-->
            <div class="user-school">{{ school }}</div>
          </div>
        </div>
        <!--                  v-if="downSelect"-->
        <el-dropdown-menu slot="dropdown" class="el-dropdown-select-option">
          <el-dropdown-item command="userinfo" icon="iconfont lwicon-cli-user">个人中心</el-dropdown-item>
          <!--          <el-dropdown-item command="editPassword" icon="iconfont icon-edit">修改密码</el-dropdown-item>-->
          <el-dropdown-item command="switchGarden" icon="iconfont lwicon-qiehuanyuanqu">切换园区</el-dropdown-item>
          <el-dropdown-item command="loginOut" icon="iconfont lwicon-tuichuzhanghao">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <lw-modal :title="title" type="primary" size="small" @onCancel="userinfoClose" :visible="userinfoVisible"
      :width="parseInt('800')">
      <div class="lw-y-user-info-body-solt" slot="body">
        <div class="user-info-body-solt-head">
          <el-avatar :src="imgSrc" :key="imgSrc"></el-avatar>
          <!--                    <el-image :src="imgSrc" :key="imgSrc" ></el-image>-->
          <!--          <img v-lazy="imgSrc" :key="imgSrc" alt=" "/>-->
          <div class="user-info-body-solt-head-right">
            <div class="solt-head-right-title">
              <span>{{ name }}</span>
            </div>
            <div class="solt-head-right-desc">
              <div class="solt-head-right-desc-school">
                <span :title="school">{{ school }}</span>
              </div>
              <div class="solt-head-right-desc-editpassword" @click="editpasswordClick">
                <span>修改密码</span>
              </div>
            </div>
          </div>
        </div>
        <div class="user-info-body-solt-content">
          <div class="user-info-body-solt-content-phone">
            <div class="solt-content-phone-title"><span>手机</span></div>
            <div class="solt-content-phone-number">
              <span>{{ phoneFormat(userInfo.bindPhone) }}</span>
            </div>
            <!--            <div class="solt-content-phone-tool" @click="editPhoneClick"><span>更换手机号</span></div>-->
          </div>
          <div class="user-info-body-solt-content-error" style="min-height: 20px; line-height: 20px">
            <div></div>
            <div></div>
          </div>
          <div class="user-info-body-solt-content-email">
            <div class="solt-content-email-title"><span>电子邮箱</span></div>
            <div class="solt-content-email-result" v-show="!editEmailType">
              {{ userInfo.email }}
              <!--              <span class="iconfont lwicon-bianji"-->
              <!--                                       @click="editEmailClick"></span>-->
            </div>
            <div class="solt-content-email-input" v-show="editEmailType">
              <el-input v-model="email" placeholder="请输入邮箱地址,非必填" maxlength="70" @focus="userInfoEmaiError = ''">
              </el-input>
              <div class="solt-content-email-tool">
                <span class="iconfont lwicon-tijiao" @click="editEmailOKClick"></span>

                <span class="iconfont lwicon-iconset0127" @click="editEmailCloseClick"></span>
              </div>
            </div>
          </div>
          <div class="user-info-body-solt-content-error">
            <div></div>
            <div>{{ userInfoEmaiError }}</div>
          </div>
          <div class="user-info-body-solt-content-wechat">
            <div class="solt-content-wechat-title"><span>微信</span></div>
            <div class="solt-content-wechat-result" v-show="!editWechatType">
              {{ userInfo.wechat }}
              <!--              <span class="iconfont lwicon-bianji"-->
              <!--                                        @click="editWechatClick"></span>-->
            </div>
            <div class="solt-content-wechat-input" v-show="editWechatType">
              <el-input v-model="wechat" placeholder="6-20个字母、数字、下划线和减号（字母开头）,非必填" maxlength="20"
                @focus="userInfoWechatError = ''"></el-input>
              <div class="solt-content-wechat-tool">
                <span class="iconfont lwicon-tijiao" @click="editWechatOKClick"></span>

                <span class="iconfont lwicon-iconset0127" @click="editWechatCloseClick"></span>
              </div>
            </div>
          </div>
          <div class="user-info-body-solt-content-error">
            <div></div>
            <div>{{ userInfoWechatError }}</div>
          </div>

          <div class="user-info-body-solt-content-qq">
            <div class="solt-content-qq-title"><span>QQ</span></div>
            <div class="solt-content-qq-result" v-show="!editQQType">
              {{ userInfo.qq }}
              <!--              <span class="iconfont lwicon-bianji"-->
              <!--                                    @click="editQQClick"></span>-->
            </div>
            <div class="solt-content-qq-input" v-show="editQQType">
              <el-input v-model="qq" placeholder="5-11位数字,非必填" maxlength="11" @focus="userInfoQQError = ''"></el-input>
              <div class="solt-content-qq-tool">
                <span class="iconfont lwicon-tijiao" @click="editQQOKClick"></span>

                <span class="iconfont lwicon-iconset0127" @click="editQQCloseClick"></span>
              </div>
            </div>
          </div>
          <div class="user-info-body-solt-content-error">
            <div></div>
            <div>{{ userInfoQQError }}</div>
          </div>
        </div>
      </div>
      <div class="lw-y-user-info-footer-solt" slot="footer">
        <lw-button type="primary" @click="userinfoClose">关闭</lw-button>
      </div>
    </lw-modal>
    <el-dialog :visible.sync="editPasswordVisible" @close="editPasswordClose" center :modal="modalShade"
      :close-on-click-modal="false" class="user-info-body-solt-editpassword" title="修改密码">
      <div class="user-info-body-solt-img-layout" v-show="editPasswordStart">
        <img src="../../assets/images/success.png" alt="" v-show="editPasswordStateType" />

        <img src="../../assets/images/error.png" alt="" v-show="!editPasswordStateType" />
        <span v-show="editPasswordStateType">修改密码成功!</span>
        <span v-show="!editPasswordStateType">修改密码失败!</span>
      </div>
      <div class="user-info-body-solt-editpassword-content" v-show="!editPasswordStart">
        <div class="user-info-body-solt-editpassword-content-password">
          <div class="solt-content-email-title"><span>原密码:</span></div>
          <div class="solt-content-email-input">
            <el-input v-model="oldPassword" placeholder="请输入原密码" show-password maxlength="30" @blur="oldPasswordBlur"
              @focus="oldPasswordFocusFunc"></el-input>
          </div>
        </div>
        <!--            -->
        <div class="user-info-body-solt-editpassword-content-password-tool">
          <div></div>
          <div class="content-password-tool">
            <div class="content-password-tool-on" v-show="oldPasswordEmpty">
              <!--              <span :class="oldPasswordOne?'el-icon-success':'el-icon-error'"><em>原密码不能为空</em></span>-->
              <span class="font-error"><em>原密码不能为空</em></span>
            </div>
            <div class="content-password-tool-on" v-show="!oldPasswordEmpty && oldPasswordOne">
              <!--              :class="oldPasswordOne?'el-icon-success':'el-icon-error'"-->
              <span class="font-error"><em>6-30个字符</em></span>
            </div>
            <div class="content-password-tool-on" v-show="!oldPasswordEmpty && !oldPasswordTwo">
              <!--              :class="oldPasswordTwo?'el-icon-success':'el-icon-error'"-->
              <span class="font-error"><em>原密码错误</em></span>
            </div>
            <!--                <div class="content-password-tool-on">-->
            <!--                  <span :class="newPasswordTwo?'el-icon-success':'el-icon-error'"><em>至少1位大写字母、小写字母、数字、特殊字符</em></span>-->
            <!--                </div>-->
          </div>
        </div>
        <div class="user-info-body-solt-editpassword-content-password">
          <div class="solt-content-email-title"><span>新密码:</span></div>
          <div class="solt-content-email-input">
            <el-input v-model="newPassword" placeholder="请输入新密码" show-password maxlength="30" @blur="newPasswordBlur"
              @focus="newPasswordFocusFunc"></el-input>
          </div>
        </div>
        <!--      v-if="newPasswordFocus"     -->
        <div class="user-info-body-solt-editpassword-content-password-tool">
          <div></div>
          <div class="content-password-tool">
            <div class="content-password-tool-on" v-show="newPasswordEmpty">
              <!--              <span :class="oldPasswordOne?'el-icon-success':'el-icon-error'"><em>原密码不能为空</em></span>-->
              <span class="font-error"><em>新密码不能为空</em></span>
            </div>

            <div class="content-password-tool-on" v-show="!newPasswordEmpty && newPasswordOne">
              <!--              :class="newPasswordOne?'el-icon-success':'el-icon-error'"-->
              <span class="font-error"><em>6-30个字符</em></span>
            </div>
            <div class="content-password-tool-on" v-show="!newPasswordEmpty && newPasswordTwo">
              <!--              :class="newPasswordTwo?'el-icon-success':'el-icon-error'"-->
              <span class="font-error"><em>至少1位大写字母、小写字母、数字、特殊字符</em></span>
            </div>
            <div class="content-password-tool-on" v-show="!newPasswordEmpty && newPasswordThird">
              <!--              :class="newPasswordThird?'el-icon-success':'el-icon-error'"-->
              <span class="font-error"><em>新密码不能与原密码相同</em></span>
            </div>
          </div>
        </div>
        <div class="user-info-body-solt-editpassword-content-password">
          <div class="solt-content-email-title"><span>确认密码:</span></div>
          <div class="solt-content-email-input">
            <el-input v-model="confirmPassword" placeholder="请再次输入新密码" show-password maxlength="30"
              @blur="confirmPasswordBlur" @focus="confirmPasswordFocusFunc"></el-input>
          </div>
        </div>
        <!--       v-if="confirmPasswordFocus"     -->
        <div class="user-info-body-solt-editpassword-content-password-tool">
          <div></div>
          <div class="content-password-tool">
            <!--            <div class="content-password-tool-on" v-show="confirmPasswordEmpty">-->
            <!--              &lt;!&ndash;              <span :class="oldPasswordOne?'el-icon-success':'el-icon-error'"><em>原密码不能为空</em></span>&ndash;&gt;-->
            <!--              <span class="font-error"><em>确认密码不能为空</em></span>-->
            <!--            </div>-->
            <!--            <div class="content-password-tool-on">-->
            <!--              <span :class="confirmPasswordOne?'el-icon-success':'el-icon-error'"><em>6-30个字符</em></span>-->
            <!--            </div>-->
            <!--            <div class="content-password-tool-on">-->
            <!--                  <span-->
            <!--                    :class="confirmPasswordTwo?'el-icon-success':'el-icon-error'"><em>至少1位大写字母、小写字母、数字、特殊字符</em></span>-->
            <!--            </div>-->
            <div class="content-password-tool-on" v-show="confirmPasswordThird">
              <!--              :class="confirmPasswordThird?'el-icon-success':'el-icon-error'"-->
              <span class="font-error"><em>两次输入密码不一致</em></span>
            </div>
          </div>
        </div>

        <div class="user-info-body-solt-editpassword-content-error">
          <div class="solt-content-email-title"><span></span></div>
          <div class="solt-content-error">
            {{ editPasswordError }}
          </div>
        </div>
      </div>

      <div class="user-info-body-solt-editpassword-footer">
        <lw-button v-show="!editPasswordStart" @click="editPasswordVisible = false">取消</lw-button>

        <lw-button type="primary" v-show="!editPasswordStart" :disabled="editPasswordComputed" @click="editPasswordOk">
          确定
        </lw-button>

        <lw-button type="primary" v-show="editPasswordStart" @click="editPasswordVisible = false">确定
        </lw-button>
      </div>
    </el-dialog>

    <!-- 修改手机号弹框 -->
    <el-dialog :visible.sync="dialogFormCellphone" @close="dialogFormCellphoneClose" center :modal="modalShade"
      :close-on-click-modal="false" class="user-info-body-solt-editphone" title="修改手机号">
      <div class="user-info-body-solt-img-layout" v-show="editPhoneStart">
        <img src="../../assets/images/success.png" alt="" v-show="editPhoneStateType" />

        <img src="../../assets/images/error.png" alt="" v-show="!editPhoneStateType" />
        <span v-show="editPhoneStateType">修改手机号成功!</span>
        <span v-show="!editPhoneStateType">修改手机号失败!</span>
      </div>
      <div class="user-info-body-solt-editphone-layout" v-show="!editPhoneStart">
        <div class="user-info-body-solt-editphone-head">
          <span v-if="firstEditPhone">验证已绑定手机号码</span>
          <span v-else>验证新绑定手机号码</span>
        </div>

        <div class="user-info-body-solt-editphone-content">
          <div class="solt-editphone-content-phone" v-if="firstEditPhone">
            <!--                <el-input-->
            <!--                  :disabled="firstEditPhone"-->
            <!--                  :value="phoneFormat(userInfo.cellphone)">-->
            <!--                </el-input>-->
            <div class="solt-editphone-content-phone-title">
              <span style="font-size: 18px">当前号码:</span>{{ phoneFormat(userInfo.cellphone) }}
            </div>
            <div class="solt-editphone-content-btn-group">
              <div v-show="sendAuthCode" class="solt-editphone-content-verifycode-btn" @click="verification">
                <span> {{ sendAuth }} </span>
              </div>
              <div v-show="!sendAuthCode" class="solt-editphone-content-authtime-btn">
                <span>{{ `${authTime}s` }} </span>
              </div>
            </div>
          </div>
          <div class="solt-editphone-content-phone" v-else>
            <el-input type="phone" :disabled="firstEditPhone" maxlength="50" v-model="cellphone.phoneNum"
              @blur="phoneChange" @focus="editPhoneError = ''" :placeholder="placeholder"></el-input>
          </div>
          <div class="solt-editphone-content-error">
            {{ editPhoneError }}
          </div>
          <div class="solt-editphone-content-verifycode">
            <el-input placeholder="输入上面手机号收到的验证码" v-model="cellphone.code"
              @input="cellphone.code = cellphone.code.replace(/[^\d]/g, '')" @focus="editPhoneCodeError = ''"
              @blur="codeBlur" maxlength="6" minlength="6"></el-input>

            <!--                @keyup.enter.native="loginSub"-->
            <div class="solt-editphone-content-btn-group" v-if="!firstEditPhone">
              <div v-show="sendAuthCode" class="solt-editphone-content-verifycode-btn" @click="verification">
                <span> {{ sendAuth }} </span>
              </div>
              <div v-show="!sendAuthCode" class="solt-editphone-content-authtime-btn">
                <span>{{ `${authTime}s` }} </span>
              </div>
            </div>
          </div>
          <div class="solt-editphone-content-error" style="min-height: 20px">
            {{ editPhoneCodeError }}
          </div>
          <div class="solt-editphone-content-desc" v-if="firstEditPhone">
            <el-button type="text" @click="noReceiveVerifycodeVisible = true">收不到验证码？</el-button>
          </div>
        </div>
      </div>
      <div class="user-info-body-solt-editphone-footer">
        <lw-button v-show="firstEditPhone" @click="dialogFormCellphone = false">取消</lw-button>

        <lw-button type="primary" v-show="firstEditPhone" :disabled="nextEditPhoneComputed" @click="nextEditPhone">下一步
        </lw-button>

        <lw-button type="primary" v-show="!firstEditPhone" :disabled="editOkComputed" @click="editOk">确定</lw-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="noReceiveVerifycodeVisible" center :modal="modalShade"
      class="user-info-body-solt-no-receive-verify-code" title="收不到验证码提示说明">
      <div class="user-info-body-solt-no-receive-verify-code-content">
        <p>{{ cannotReceivedCodeMessageDate.name }}：</p>
        <div v-for="(item, index) in cannotReceivedCodeMessageDate.point" :key="index">
          <span>{{ index + 1 + "、" + item.name }}：</span>
          <span v-html="item.description" />
        </div>
      </div>
      <div class="user-info-body-solt-no-receive-verify-code-footer">
        <lw-button type="primary" @click="noReceiveVerifycodeVisible = false">我知道了</lw-button>
      </div>
    </el-dialog>

    <lw-modal :visible="editGardenVisible" type="primary" :title="'切换园区'" size="small" :height="parseInt('400')"
      @onCancel="editGardenVisible = false">
      <div class="lw-y-edit-garden-body-solt" slot="body">
        <div class="lw-y-edit-garden-body-solt-title">
          <span>当前园区:</span>
        </div>
        <div class="lw-y-edit-garden-body-solt-select">
          <!--          v-model="value"-->
          <el-select placeholder="请选择" v-model="gardenIdV" :popper-append-to-body="popperAppendToBody">
            <el-option v-for="item in userGerdenList" :key="item.gardenId" :label="item.gardenName"
              :value="item.gardenId">
            </el-option>
          </el-select>
        </div>
      </div>
      <div slot="footer" class="lw-y-edit-garden-footer-solt">
        <lw-button type="primary" @click="okGardenClick">确定</lw-button>
      </div>
    </lw-modal>
  </div>
</template>

<script>
// import AuthService from "@/services/auth.service";
import Modification from "@/services/modification.service";
import CryptoJS from "crypto-js";
import cannotReceivedCodeMessageDate from "./modal.js";

export default {
  name: "userInfo",
  data() {
    return {
      posionLeft: 0,
      logSrc: require("@/assets/images/bjcsxy-logo.png"),
      downSelect: false,
      name: "",
      school: "",
      schoolAll: "",
      imgSrc: "",
      refresh: true,
      userInfo: {},
      email: "",
      wechat: "",
      qq: "",

      footer: false,
      editEmailType: false,
      editWechatType: false,
      editQQType: false,

      userinfoVisible: false,
      editGardenVisible: false,

      editPasswordVisible: false,

      title: "个人中心",
      dialogFormCellphone: false,
      noReceiveVerifycodeVisible: false,
      cannotReceivedCodeMessageDate: cannotReceivedCodeMessageDate,

      // 手机号码第一步
      firstEditPhone: true,
      editPhoneStateType: false,
      editPhoneStart: false,
      modalShade: false,
      cellphone: {
        phoneNum: "",
        code: "",
      },
      placeholder: "请输入已绑定手机号",
      sendAuthCode: true /* 布尔值，通过v-show控制显示‘获取按钮’还是‘倒计时’ */,
      sendAuth: "发送验证码",
      authTime: 0 /*, 倒计时 计数器*/,
      editPhoneError: "",
      editPhoneCodeError: "",

      userInfoEmaiError: "",
      userInfoWechatError: "",
      userInfoQQError: "",

      editPasswordStart: false,
      editPasswordStateType: false,
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
      editPasswordError: "",
      oldPasswordEmpty: false,
      oldPasswordOne: false,
      oldPasswordTwo: true,
      oldPasswordFocus: false,

      newPasswordFocus: false,
      newPasswordEmpty: false,
      newPasswordOne: false,
      newPasswordTwo: false,
      newPasswordThird: false,

      confirmPasswordEmpty: false,
      confirmPasswordOne: false,
      confirmPasswordTwo: false,
      confirmPasswordThird: false,
      confirmPasswordFocus: false,
      userGerdenList: [],
      gardenIdV: "",
      popperAppendToBody: false,

      timer: null,
    };
  },
  async mounted() {
    let clientWidth = document.body.clientWidth;
    let bgWidth = 1920;
    if (clientWidth > bgWidth) {
      this.posionLeft = (clientWidth - bgWidth) / 2;
    } else {
      this.posionLeft = 0;
    }
    window.onresize = () => {
      return (() => {
        this.$nextTick(() => {
          let clientWidth = document.body.clientWidth;
          let bgWidth = 1920;
          if (clientWidth > bgWidth) {
            this.posionLeft = (clientWidth - bgWidth) / 2;
          } else {
            this.posionLeft = 0;
          }
        });
      })();
    };
    await this.userGerdenListF();

    let userInfo = this.local$.getItem("userInfo");
    // let userId = this.local$.getItem("userId");
    this.gardenIdV = this.local$.getItem("gardenId");
    this.setSchool();
    // this.school = userInfo.gardens && userInfo.gardens.length > 0 ? userInfo.gardens[0].gardenName : ''
    // this.schoolAll = userInfo.gardens && userInfo.gardens.length > 0 ? userInfo.gardens[0].gardenFullName : ''
    if (userInfo) {
      userInfo = JSON.parse(userInfo);
      // this.name = userInfo.displayName
      this.name = userInfo.name;
      if (userInfo.imgUrl) {
        this.imgSrc = this.filePre$.headImgUrl + userInfo.imgUrl;
      } else {
        this.imgSrc = require("../../assets/images/defaultHead.png");
      }
    } else {
      this.imgSrc = require("../../assets/images/defaultHead.png");
    }
  },
  computed: {
    nextEditPhoneComputed() {
      let code = this.cellphone.code;
      if (!code || (code && code.length != 6)) {
        return true;
      }
      if (this.cellphone.phoneNum === "") {
        return true;
      }
      return false;
    },
    editOkComputed() {
      if (!this.editPhoneStart) {
        let code = this.cellphone.code;
        if (!code || (code && code.length != 6)) {
          return true;
        }
        if (this.cellphone.phoneNum === "") {
          return true;
        }
        if (this.editPhoneCodeError != "" || this.editPhoneError != "") {
          return true;
        }
        return false;
      }

      return false;
    },

    editPasswordComputed() {
      var regex = new RegExp(
        "(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])."
      );

      // if (this.oldPassword && this.oldPassword.length > 5 && this.oldPassword.length < 31) {
      if (this.oldPassword) {
        if (
          this.newPassword &&
          this.newPassword.length > 5 &&
          this.newPassword.length < 31 &&
          this.oldPassword !== this.newPassword &&
          regex.test(this.newPassword)
        ) {
          if (this.newPassword === this.confirmPassword) {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
  },
  methods: {
    editEmailClick() {
      this.editEmailType = true;
      this.email = this.userInfo.email;
    },

    editEmailOKClick() {
      if (this.email) {
        if (
          !/[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/.test(
            this.email
          )
        ) {
          this.userInfoEmaiError = "邮箱格式错误";
          return true;
        }
      }
      this.okModal({ email: this.email });
      this.userInfo.email = this.email;
      this.editEmailCloseClick();
    },
    editEmailCloseClick() {
      this.editEmailType = false;
      this.email = "";
      this.userInfoEmaiError = "";
    },

    editWechatClick() {
      this.editWechatType = true;
      this.wechat = this.userInfo.wechat;
    },
    editWechatOKClick() {
      if (this.wechat) {
        // 可以使用6—20个字母、数字、下划线和减号，必须以字母开头（不区分大小写），不支持设置中文，仅能设置1次。
        if (!/^[a-zA-Z][a-zA-Z0-9_-]{5,19}$/.test(this.wechat)) {
          this.userInfoWechatError = "微信号格式错误";
          return false;
        }
      }
      this.okModal({ wechat: this.wechat });
      this.userInfo.wechat = this.wechat;
      this.editWechatCloseClick();
    },
    editWechatCloseClick() {
      this.editWechatType = false;
      this.wechat = "";
      this.userInfoWechatError = "";
    },

    editQQClick() {
      this.editQQType = true;
      this.qq = this.userInfo.qq;
    },
    async editQQOKClick() {
      if (this.qq) {
        if (!/^[1-9][0-9]{5,11}$/.test(this.qq)) {
          this.userInfoQQError = "QQ号格式错误";
          return true;
        }
      }
      await this.okModal({ qq: this.qq });
      this.userInfo.qq = this.qq;
      this.editQQCloseClick();
    },
    editQQCloseClick() {
      this.editQQType = false;
      this.qq = "";
      this.userInfoQQError = "";
    },

    editpasswordClick() {
      this.userinfoVisible = false;

      this.editPasswordStart = false;
      this.editPasswordStateType = false;

      this.oldPassword = "";
      this.newPassword = "";
      this.confirmPassword = "";
      this.editPasswordError = "";
      this.editPasswordVisible = true;

      this.oldPasswordEmpty = false;
      this.oldPasswordOne = false;
      this.oldPasswordTwo = true;
      this.oldPasswordFocus = false;

      this.newPasswordFocus = false;
      this.newPasswordEmpty = false;
      this.newPasswordOne = false;
      this.newPasswordTwo = false;
      this.newPasswordThird = false;

      this.confirmPasswordEmpty = false;
      this.confirmPasswordOne = false;
      this.confirmPasswordTwo = false;
      this.confirmPasswordThird = false;
      this.confirmPasswordFocus = false;
    },
    editPasswordClose() {
      this.userinfoVisible = true;
    },
    oldPasswordBlur() {
      if (this.oldPassword) {
        this.oldPasswordEmpty = false;
        // this.oldPasswordOne = !(this.oldPassword.length > 5 && this.oldPassword.length < 31)
      } else {
        this.oldPasswordEmpty = true;
      }

      if (
        !this.oldPasswordEmpty &&
        !this.oldPasswordOne &&
        !this.newPasswordOne &&
        !this.newPasswordTwo &&
        this.oldPassword === this.newPassword
      ) {
        this.newPasswordThird = true;
      } else {
        this.newPasswordThird = false;
      }

      if (this.oldPasswordEmpty || this.oldPasswordOne) {
        return true;
      } else {
        return false;
      }
      // if (!this.oldPasswordOne) {
      //   return
      // }
      // this.oldPasswordFocus = false
    },
    oldPasswordFocusFunc() {
      this.oldPasswordEmpty = false;
      this.oldPasswordOne = false;
      // this.oldPasswordTwo = true
      // this.oldPasswordFocus = true
    },
    async newPasswordBlur() {
      let oneTy = await this.oldPasswordBlur();

      if (oneTy) {
        return true;
      }

      var regex = new RegExp(
        "(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])."
      );
      if (this.newPassword) {
        this.newPasswordEmpty = false;
        this.newPasswordOne = !(
          this.newPassword.length > 5 && this.newPassword.length < 31
        );
        this.newPasswordTwo = !regex.test(this.newPassword);
      } else {
        this.newPasswordEmpty = true;
      }

      if (
        !this.oldPasswordEmpty &&
        !this.oldPasswordOne &&
        !this.newPasswordOne &&
        !this.newPasswordTwo &&
        this.oldPassword === this.newPassword
      ) {
        this.newPasswordThird = true;
      } else {
        this.newPasswordThird = false;
      }

      if (
        !this.newPasswordEmpty &&
        !this.newPasswordOne &&
        !this.newPasswordTwo &&
        // && !this.confirmPasswordOne && !this.confirmPasswordTwo
        this.confirmPassword !== "" &&
        this.newPassword !== this.confirmPassword
      ) {
        this.confirmPasswordThird = true;
      } else {
        this.confirmPasswordThird = false;
      }

      if (this.newPasswordEmpty || this.newPasswordOne || this.newPasswordTwo) {
        return true;
      } else {
        return false;
      }

      // if (!this.newPasswordOne || !this.newPasswordTwo || !this.newPasswordThird) {
      //   return
      // }
      // this.newPasswordFocus = false
    },
    newPasswordFocusFunc() {
      this.newPasswordFocus = true;
    },

    async confirmPasswordBlur() {
      let oneTy = await this.newPasswordBlur();
      if (oneTy) {
        return true;
      }

      if (
        !this.newPasswordEmpty &&
        !this.newPasswordOne &&
        !this.newPasswordTwo &&
        // && !this.confirmPasswordOne && !this.confirmPasswordTwo
        this.newPassword !== this.confirmPassword
      ) {
        this.confirmPasswordThird = true;
      } else {
        this.confirmPasswordThird = false;
      }

      if (this.confirmPasswordThird) {
        return true;
      } else {
        return false;
      }

      // if (!this.confirmPasswordOne || !this.confirmPasswordTwo || !this.confirmPasswordThird) {
      //   return
      // }
      // this.confirmPasswordFocus = false
    },
    confirmPasswordFocusFunc() {
      this.confirmPasswordFocus = true;
    },

    async editPasswordOk() {
      // if (!this.oldPasswordOne) {
      //   this.oldPasswordFocusFunc()
      //   return
      // }
      // if (!this.newPasswordOne || !this.newPasswordTwo || !this.newPasswordThird) {
      //   this.newPasswordFocusFunc()
      //   return
      // }
      // if (!this.confirmPasswordOne || !this.confirmPasswordTwo || !this.confirmPasswordThird) {
      //   this.confirmPasswordFocusFunc()
      //   return
      // }

      let oneTy = await this.confirmPasswordBlur();
      if (oneTy) {
        return true;
      }
      // key编码
      const randomNumber = this.generateRandomNum();
      var userKey = this.oldPassword + randomNumber;
      var keyHex = CryptoJS.enc.Utf8.parse(userKey);
      const encryptPassword = CryptoJS.DES.encrypt(this.newPassword, keyHex, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }).toString();
      const parms = {
        xxx: userKey,
        zzz: encryptPassword,
      };
      let that = this;
      Modification.updatePassword(parms)
        .then(() => {
          // that.editPasswordVisible = false
          that.editPasswordStart = true;
          that.editPasswordStateType = true;

          // that.$message.success('密码修改成功!')
        })
        .catch((error) => {
          // 账户不存在
          // 原始密码输入错误
          if (error.error_description.includes("密码")) {
            that.oldPasswordFocusFunc();
            that.oldPasswordTwo = false;
          } else {
            that.editPasswordError = error.error_description;
          }
        });
    },
    generateRandomNum() {
      // 生成8位随机数
      var arr = [];
      for (var i = 0; i < 8; i++) {
        var index = Math.floor(Math.random() * 10);
        arr.push(index);
      }
      return arr.toString().replace(/,/g, "");
    },

    userinfoClose() {
      this.userinfoVisible = false;
    },
    async okModal(type) {
      let parms = {
        telephone: this.userInfo.telephone,
        cellphone: this.userInfo.cellphone,
        email: this.userInfo.email,
        wechat: this.userInfo.wechat,
        qq: this.userInfo.qq,
        gardenId: this.userInfo.gardenId,
        interPhone: this.userInfo.interPhone,
      };
      parms = { ...parms, ...type };

      await Modification.updateUserInfo(parms).then(async () => { });
    },
    //手机号校验
    async phoneChange() {
      let value = this.cellphone.phoneNum.replace(/\D/g, ""); //去除空格
      if (!value || "" == value) {
        this.editPhoneError = "手机号码不能为空";
        return false;
      }
      if (!/^\d{6,50}$/.test(value)) {
        this.editPhoneError = "手机号格式不正确";
        return false;
      }
      if (!this.firstEditPhone) {
        if (value == this.userInfo.cellphone) {
          this.editPhoneError = "请输入要更换的手机号";
          return false;
        }
      }

      this.editPhoneError = "";
    },

    codeBlur() {
      if (this.editPhoneCodeError != "") {
        return false;
      }
      let code = this.cellphone.code;
      if (code) {
        if (code.length == 6) {
          this.editPhoneCodeError = "";
        } else {
          this.editPhoneCodeError = "请输入6位验证码!";
          return false;
        }
      } else {
        this.editPhoneCodeError = "验证码不能为空!";
        return false;
      }
    },

    // 点击发送验证码时倒计时
    async verification() {
      if (this.cellphone.phoneNum === "") {
        this.editPhoneError = "手机号不能为空！";
        return;
      }
      await this.phoneChange();
      if (this.editPhoneError != "") {
        return;
      }

      let phone = this.cellphone.phoneNum.replace(/\D/g, ""); //去除空格
      let parms = {
        accountId: this.userInfo.id,
        cellphone: phone,
      };
      const scene = this.firstEditPhone
        ? "TEACHER_MODIFY_MOBILE_BIND"
        : "TEACHER_MODIFY_MOBILE_NEW";
      if (this.firstEditPhone) {
        // 发送验证码接口
        Modification.checkBindCellphone(parms)
          .then(async () => {
            // 已绑定手机号正确时，获取倒计时，发送验证码
            await this.sendVerficationCode(scene);
          })
          .catch(() => {
            // this.editPhoneError = error.error_description
          });
      } else {
        await this.sendVerficationCode(scene);
      }
      //
      // this.sendAuthCode = false
      // this.authTime = 60
      //
      // var auth_timetimer = setInterval(() => {
      //   this.authTime--
      //   if (this.authTime <= 0) {
      //     this.sendAuthCode = true
      //     clearInterval(auth_timetimer)
      //   }
      // }, 1000)
      // this.sendAuth = '重新发送'
    },
    async sendVerficationCode(scene) {
      let phone = this.cellphone.phoneNum.replace(/\D/g, ""); //去除空格
      const params = {
        cellphone: phone,
        scene: scene,
      };
      await Modification.getVerficationCodeCountDown(params).then(
        async (res) => {
          if (res.state !== "1") {
            this.authTime = res.lockTime;
          } else {
            // 发送验证码
            Modification.sendVerficationCode(params)
              .then(() => { })
              .catch(() => {
                // this.promptmessage = error.error_description
              });
            this.authTime = 60;
          }
          this.sendAuthCode = false;
          await this.beginCountDown();
        }
      );
    },
    beginCountDown() {
      var auth_timetimer = setInterval(() => {
        this.authTime--;
        if (this.authTime <= 0) {
          this.sendAuthCode = true;
          clearInterval(auth_timetimer);
        }
      }, 1000);
      this.sendAuth = "重新发送";
    },
    getAuthDetailInfo() {
      let userInfo = window.localStorage.getItem("userInfo");

      // AuthService.getStudentAuthInfo({id: userId}).then(response => {
      //   if (response) {
      //     this.$set(response, 'accountId', response.id)
      //     if (userInfo) {
      //       userInfo = JSON.parse(userInfo)
      //       if (userInfo.gardens) {
      //         this.$set(response, 'gardens', userInfo.gardens)
      //       }
      //     }
      //     this.userInfo = response
      //     this.name = this.userInfo.name
      //     window.localStorage.setItem('displayName', response.name)
      //     window.localStorage.setItem('userInfo', JSON.stringify(response))
      //     this.$emit('changeName')
      //   }
      //   this.editEmailCloseClick()
      //   this.editWechatCloseClick()
      //   this.editQQCloseClick()
      //
      // })
      if (userInfo) {
        this.userInfo = JSON.parse(userInfo);
      }
      this.editEmailCloseClick();
      this.editWechatCloseClick();
      this.editQQCloseClick();
    },
    // getUserInfo() {
    //   AuthService.getAuthInfo().then(response => {
    //
    //     if (response) {
    //       // 缓存用户信息
    //       window.localStorage.setItem('userId', response.accountId)
    //       window.localStorage.setItem('displayName', response.displayName)
    //       window.localStorage.setItem('userInfo', JSON.stringify(response))
    //       if (response.gardens && response.gardens[0]) {
    //         window.localStorage.setItem('gardenId', response.gardens[0].gardenId)
    //       }
    //       // this.$router.push({
    //       //   path: "/excellentField"
    //       // });
    //     }
    //   })
    // },

    phoneFormat(number) {
      if (!number) {
        return;
      }
      let value = number.toString().replace(/\D/g, "").slice(0, 11); //去除空格
      let valLength = value.length;
      switch (true) {
        case valLength > 3 && valLength < 8:
          value = `${value.slice(0, 3)} ${value.slice(3)}`;
          break;
        case valLength >= 8:
          // value = `${value.substr(0, 3)} ${value.substr(3, 4)} ${value.substr(7)}`
          value = `${value.substr(0, 3)} **** ${value.substr(7)}`;
          break;
        default:
          break;
      }
      return value;
    },
    editPhoneClick() {
      this.userinfoVisible = false;
      this.cellphone.phoneNum = this.userInfo.cellphone;
      this.dialogFormCellphone = true;
      this.firstEditPhone = true;
      this.editPhoneStart = false;
      this.editPhoneError = "";
    },
    dialogFormCellphoneClose() {
      this.userinfoVisible = true;
      this.dialogFormCellphone = false;
    },
    async nextEditPhone() {
      // this.firstEditPhone = false
      // return
      await this.codeBlur();
      if (this.editPhoneCodeError != "" || this.editPhoneError != "") {
        return false;
      }
      if (this.cellphone.phoneNum === "") {
        this.editPhoneError = "手机号不能为空！";
        return;
      }
      if (this.cellphone.code === "") {
        this.editPhoneCodeError = "验证码不能为空！";
        return;
      }
      let phone = this.cellphone.phoneNum.replace(/\D/g, ""); //去除空格
      const param = {
        cellphone: phone,
        scene: "TEACHER_MODIFY_MOBILE_BIND",
        code: this.cellphone.code,
        accountId: this.userInfo.id,
      };

      let that = this;
      await Modification.checkVerficationCode(param)
        .then(
          () => {
            that.firstEditPhone = false;
            that.placeholder = "请输入要更换的手机号";
            that.cellphone.phoneNum = "";
            this.cellphone.code = "";
            that.sendAuthCode = true;
            that.sendAuth = "发送验证码";
          },
          (error) => {
            that.editPhoneCodeError = error.error_description;
          }
        )
        .catch((error) => {
          that.editPhoneCodeError = error.error_description;
        });
    },

    /**
     * 第二部修改新的手机号
     */
    async editOk() {
      // this.editPhoneStart = true
      // return
      /**
       * 关闭弹窗
       */
      if (this.editPhoneStart) {
        this.dialogFormCellphone = false;
        this.editPhoneStart = false;
      } else {
        /**
         * 提交 手机号码
         * @type {boolean}
         */
        await this.codeBlur();

        if (this.editPhoneCodeError != "" || this.editPhoneError != "") {
          return false;
        }

        if (this.cellphone.phoneNum === "") {
          this.editPhoneError = "手机号不能为空！";
          return;
        }
        if (this.cellphone.code === "") {
          this.editPhoneCodeError = "验证码不能为空！";
          return;
        }
        let phone = this.cellphone.phoneNum.replace(/\D/g, ""); //去除空格
        const param = {
          cellphone: phone,
          code: this.cellphone.code,
          accountId: this.userInfo.id,
        };

        await Modification.mobilconfirm(param)
          .then(() => {
            this.editPhoneStart = true;
            this.editPhoneStateType = true;
            this.cellphone.code = "";
            this.sendAuthCode = true;
            this.sendAuth = "发送验证码";
            this.getAuthDetailInfo(this.userInfo.id);
          })
          .catch((error) => {
            this.editPhoneCodeError = error.error_description;
          });
      }
    },

    visibleChange(e) {
      this.downSelect = e;
    },

    userinfo() {
      this.userinfoVisible = true;
      let userId = this.local$.getItem("userId");

      this.getAuthDetailInfo(userId);
    },

    switchGarden() {
      this.editGardenVisible = true;
    },
    setSchool() {
      let number = this.userGerdenList.findIndex(
        (n) => n.gardenId == this.gardenIdV
      );
      if (-1 != number) {
        this.school = this.userGerdenList[number].gardenName;
        let userInfo = window.localStorage.getItem("userInfo");
        if (userInfo) {
          userInfo = JSON.parse(userInfo);
          if (userInfo.gardens && userInfo.gardens[0]) {
            userInfo.gardens[0] = this.userGerdenList[number];
          } else {
            userInfo.gardens = [this.userGerdenList[number]];
          }
          window.localStorage.setItem("userInfo", JSON.stringify(userInfo));
        }
      }
    },
    async okGardenClick() {
      let item = window.localStorage.getItem("gardenId");
      this.editGardenVisible = false;
      if (item == this.gardenIdV) {
        return;
      }
      window.localStorage.setItem("gardenId", this.gardenIdV);
      await this.setSchool();
      this.editGardenVisible = false;

      // this.$message({
      //   type: 'success',
      //   customClass: 'garden-success',
      //   // showClose: true,
      //   message: '已切换到' + this.school + '园区!',
      // })
      let that = this;

      //获得当前的路由地址 如果是airClassRoom 要使用刷新
      if (this.$route.path.includes("airClassRoom")) {
        this.timer = setInterval(() => {
          clearInterval(this.timer);
          this.timer = null;
          // this.$router.go(0)
          // 在safari 浏览器上不能刷新页面，vue 现在也没有解决这个问题。后来百度一番发现也没有什么其他好的方法，只能用js 原生的刷新页面
          window.location.reload();
        }, 0);
      } else {
        this.timer = setInterval(() => {
          clearInterval(this.timer);
          this.timer = null;
          that.$router.push({ name: "airClassRoom" });
        }, 0);
      }
    },
    async userGerdenListF() {
      await Modification.studentGardenList().then((res) => {
        this.userGerdenList = res;
      });
    },

    handleCommand(e) {
      switch (e) {
        case "loginOut":
          this.logout();
          break;
        case "userinfo":
          this.userinfo();
          break;
        case "switchGarden":
          this.switchGarden();
          break;
        case "editPassword":
          this.editpasswordClick();
          break;
      }
    },

    logout() {
      this.cookie$.removeCookie("token");
      this.local$.clearLocal();
      let loginUrl = this.filePre$.studentLogin;
      window.open(loginUrl, "_self");

      // this.$router.push({ path: "/" });
      // this.$message.info("退出登录")
    },
  },

  watch: {
    "cellphone.phoneNum": {
      handler(nv) {
        if (!nv) {
          return;
        }
        let value = nv.replace(/\D/g, ""); //去除空格
        this.cellphone.phoneNum = value;
      },
      deep: true,
      // immediate: true,
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/scss/index.scss";

/*@import "./_lwTopBanner.scss";*/

.lw-user-info {
  width: calc(100% - 6px);
  height: calc(100% - 12px);

  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
  margin-right: 6px;

  .login-info {
    .el-dropdown-link {
      font-size: 18px;
      /*margin-top: 20px;*/
      color: #ffffff;
      cursor: pointer;
      display: flex;
      height: 50px;

      .el-image {
        margin-right: 10px;
        width: 50px;
        border-radius: 50%;
      }

      .user-info {
        max-width: 230px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        .user-info-name-layout {
          display: flex;

          .el-dropdown-link-name {
            text-align: left;
            max-width: 200px;
            font-size: 18px;

            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .down-icon {
            margin-left: 8px;

            .lwicon-shouqi {
              display: flex;
              margin-left: 5px;
              cursor: pointer;
              font-size: 21px;
              -webkit-transition: all 0.5s ease;
            }

            .down-selete {
              transform: rotate(180deg);
              -ms-transform: rotate(180deg);
              /* IE 9 */
              -moz-transform: rotate(180deg);
              /* Firefox */
              -webkit-transform: rotate(180deg);
              /* Safari 和 Chrome */
              -o-transform: rotate(180deg);
              /* Opera */
            }

            .up-selete {
              transform: rotate(0deg);
              -ms-transform: rotate(0deg);
              /* IE 9 */
              -moz-transform: rotate(0deg);
              /* Firefox */
              -webkit-transform: rotate(0deg);
              /* Safari 和 Chrome */
              -o-transform: rotate(0deg);
              /* Opera */
            }
          }
        }

        .user-school {
          font-size: 14px;
          text-align: left;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }

  .lw-y-user-info-body-solt {
    padding: 0 20px;
    width: calc(100% - 40px);

    .user-info-body-solt-head {
      width: calc(100% - 90px);
      @include pading-right;
      display: flex;
      height: 90px;
      border-bottom: 1px solid #eeeeee;

      .el-avatar {
        height: 80px;
        width: 80px;
      }

      .user-info-body-solt-head-right {
        width: calc(100% - 90px);
        padding: 10px 0px;

        margin-left: 10px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        .solt-head-right-title {
          font-size: 16px;
        }

        .solt-head-right-desc {
          font-size: 14px;
          display: flex;
          justify-content: space-between;

          .solt-head-right-desc-school {
            width: calc(100% - 100px);
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          .solt-head-right-desc-editpassword {
            text-align: right;
            width: 100px;
            color: #226cfb;
            cursor: pointer;
            font-size: 14px;
          }
        }
      }
    }

    .user-info-body-solt-content {
      @include pading-right;
      font-size: 16px;

      .user-info-body-solt-content-phone {
        /*margin-bottom: 10px;*/
        margin-top: 20px;

        .solt-content-phone-number {
          width: 130px;
        }

        .solt-content-phone-tool {
          font-size: 14px;
          color: #226cfb;
          cursor: pointer;
        }
      }

      .user-info-body-solt-content-phone,
      .user-info-body-solt-content-email,
      .user-info-body-solt-content-wechat,
      .user-info-body-solt-content-qq {
        /*border: 1px solid red;*/
        display: flex;
        height: 35px;
        line-height: 35px;

        .iconfont {
          margin-left: 10px;
          /*font-weight: bold;*/
          cursor: pointer;
          font-size: 20px;
          color: #226cfb;
        }

        .iconfont:before {
          font-size: 20px;
        }

        /*margin-top: 10px;*/

        .solt-content-phone-title,
        .solt-content-email-title,
        .solt-content-wechat-title,
        .solt-content-qq-title {
          width: 80px;
          padding-right: 10px;
          text-align: right;
        }

        .solt-content-email-result,
        .solt-content-wechat-result,
        .solt-content-qq-result {
          display: flex;
        }

        .solt-content-email-input,
        .solt-content-wechat-input,
        .solt-content-qq-input {
          display: flex;

          ::v-deep .el-input {
            .el-input__inner {
              /*border: none;*/
              width: 400px;
              /*border-bottom: 1px solid #cccccc;*/
              /*border-radius: 0px;*/
              height: 34px;
              line-height: 34px;
            }

            /*.el-input__inner:focus {*/
            /*  outline: none;*/
            /*  border-color: #226cfb;*/
            /*}*/
          }

          .solt-content-email-tool,
          .solt-content-wechat-tool,
          .solt-content-qq-tool {
            display: flex;

            .lwicon-tijiao {
              color: #19fa28;
            }

            .lwicon-iconset0127 {
              color: #d81e06;
            }
          }
        }
      }

      .user-info-body-solt-content-error {
        display: flex;
        /*height: 35px;*/
        min-height: 23px;
        line-height: 23px;

        div:first-child {
          width: 80px;
          padding-right: 10px;
          text-align: right;
        }

        color: #ff0000;
        font-size: 14px;
      }
    }
  }

  .lw-y-user-info-footer-solt {
    display: flex;
    justify-content: center;

    ::v-deep .lw-button {
      width: 120px;
    }
  }

  .user-info-body-solt-editpassword {
    display: flex;
    /*Flex布局*/
    display: -webkit-flex;
    /* Safari */
    align-items: center;
    /*指定垂直居中*/
    justify-content: center;

    ::v-deep .el-dialog {
      width: 600px;
      min-height: 400px;
      box-shadow: 0px 8px 12px 0px rgba(7, 0, 2, 0.3);

      -webkit-animation: popIn 0.4s;
      animation: popIn 0.4s;
      -webkit-animation-name: popIn;
      animation-name: popIn;

      .el-dialog__header {
        padding: 0px;
        height: 40px;
        background-color: #226cfb;
        border: 1px solid #226cfb;
        display: flex;

        .el-dialog__title {
          line-height: 40px;
          /*padding-left: 40px;*/
          color: #ffffff;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          width: calc(100%);
        }

        .el-dialog__headerbtn {
          top: 3px;
          height: 40px;
          width: 20px;
          line-height: 40px;
          color: #ffffff;
          cursor: pointer;

          .el-dialog__close {
            font-size: 24px;
            color: #ffffff;
          }
        }
      }
    }

    .user-info-body-solt-editpassword-content {
      width: 400px;
      min-height: 260px;
      margin: 0 auto;

      .user-info-body-solt-editpassword-content-password {
        display: flex;
        height: 35px;
        line-height: 35px;
        margin-top: 20px;

        .solt-content-email-title {
          width: 80px;
          padding-right: 10px;
          text-align: right;
        }

        .el-input {
          ::v-deep .el-input__inner {
            width: 310px;
            height: 34px;
            line-height: 34px;
          }
        }
      }

      .user-info-body-solt-editpassword-content-error {
        display: flex;
        height: 35px;
        line-height: 35px;

        /*margin-top: 20px;*/
        div:first-child {
          width: 80px;
          padding-right: 10px;
          text-align: right;
        }

        .solt-content-error {
          color: #ff0000;
        }
      }

      .user-info-body-solt-editpassword-content-password-tool {
        display: flex;

        div:first-child {
          width: 80px;
          padding-right: 10px;
          text-align: right;
        }

        .content-password-tool {
          width: 320px;
          margin-top: 5px;

          .content-password-tool-on {
            width: 100%;
            display: flex;
            line-height: 20px;

            .font-error {
              color: #ff0000;

              em {
                margin-left: 5px;
                font-size: 13px;
                font-style: normal;
              }
            }

            .el-icon-error {
              font-size: 16px;
              line-height: 20px;
              /*color: #a3ccf9;*/
              color: #ff0000;

              em {
                margin-left: 5px;
                font-size: 13px;
                font-style: normal;
              }
            }

            .el-icon-success {
              font-size: 16px;
              line-height: 20px;
              margin-right: 5px;
              color: #49e56c;

              em {
                margin-left: 5px;
                font-size: 13px;
                font-style: normal;
              }
            }
          }
        }
      }
    }

    .user-info-body-solt-editpassword-footer {
      display: flex;
      justify-content: center;
      text-align: center;

      ::v-deep .lw-button:first-child {
        margin-right: 20px;
      }
    }
  }

  .user-info-body-solt-img-layout {
    display: flex;
    flex-direction: column;
    /*justify-content: center;*/
    align-items: center;
    height: 280px;

    img {
      margin-top: 60px;
      width: 180px;
      height: 107px;
    }

    span {
      margin-top: 40px;
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #ff0000;
      color: #49e56c;
    }
  }

  .user-info-body-solt-editphone {
    display: flex;
    /*Flex布局*/
    display: -webkit-flex;
    /* Safari */
    align-items: center;
    /*指定垂直居中*/
    justify-content: center;

    ::v-deep .el-dialog {
      width: 600px;
      height: 400px;
      -webkit-animation: popIn 0.4s;
      animation: popIn 0.4s;
      -webkit-animation-name: popIn;
      animation-name: popIn;

      box-shadow: 0px 8px 12px 0px rgba(7, 0, 2, 0.3);

      .el-dialog__header {
        padding: 0px;
        height: 40px;
        background-color: #226cfb;
        border: 1px solid #226cfb;
        display: flex;

        .el-dialog__title {
          line-height: 40px;
          /*padding-left: 40px;*/
          color: #ffffff;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          width: calc(100%);
        }

        .el-dialog__headerbtn {
          top: 3px;
          height: 40px;
          width: 20px;
          line-height: 40px;
          color: #ffffff;
          cursor: pointer;

          .el-dialog__close {
            font-size: 24px;
            color: #ffffff;
          }
        }
      }
    }

    .user-info-body-solt-editphone-layout {
      width: 310px;
      height: 280px;
      margin: 0 auto;

      .user-info-body-solt-editphone-head {
        text-align: center;

        span {
          margin: 3px 0px;
          font-size: 16px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #226cfb;
        }
      }

      .user-info-body-solt-editphone-content {
        margin-top: 30px;

        .el-input {
          ::v-deep .el-input__inner {
            height: 34px;
            line-height: 34px;
          }
        }

        .solt-editphone-content-phone {
          display: flex;

          .solt-editphone-content-phone-title {
            /*border: 1px solid red;*/
            display: inline-block;
            line-height: 36px;
            font-size: 17px;
            font-weight: bold;
            width: 230px;
            /*width: 150px;*/
            text-align: left;
          }

          .solt-editphone-content-btn-group {
            @include solt-editphone-content-btn-group();
          }
        }

        .solt-editphone-content-verifycode {
          margin-top: 20px;
          display: flex;

          ::v-deep .el-input__inner {
            padding: 0 7px;
          }

          .solt-editphone-content-btn-group {
            @include solt-editphone-content-btn-group();
          }
        }

        .solt-editphone-content-desc {
          margin-top: 10px;

          .el-button--text {
            color: #226cfb;
            font-weight: normal;
          }
        }

        .solt-editphone-content-error {
          margin-top: 10px;
          color: #ff0000;
        }
      }
    }

    .user-info-body-solt-editphone-footer {
      display: flex;
      justify-content: center;
      text-align: center;

      .lw-button {
        margin-right: 20px;
      }

      /*align-items: flex-end;*/
    }
  }

  .user-info-body-solt-no-receive-verify-code {
    display: flex;
    /*Flex布局*/
    display: -webkit-flex;
    /* Safari */
    align-items: center;
    /*指定垂直居中*/
    justify-content: center;

    ::v-deep .el-dialog {
      width: 600px;
      height: 600px;
      box-shadow: 0px 8px 12px 0px rgba(7, 0, 2, 0.3);
      -webkit-animation: popIn 0.4s;
      animation: popIn 0.4s;
      -webkit-animation-name: popIn;
      animation-name: popIn;

      .el-dialog__header {
        padding: 0px;
        height: 40px;
        background-color: #226cfb;
        border: 1px solid #226cfb;
        display: flex;

        .el-dialog__title {
          line-height: 40px;
          /*padding-left: 40px;*/
          color: #ffffff;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          width: calc(100%);
        }

        .el-dialog__headerbtn {
          top: 3px;
          height: 40px;
          width: 20px;
          line-height: 40px;
          color: #ffffff;
          cursor: pointer;

          .el-dialog__close {
            font-size: 24px;
            color: #ffffff;
          }
        }
      }
    }

    .user-info-body-solt-no-receive-verify-code-content {
      padding: 0 20px;
      width: calc(100% - 20px);

      height: calc(470px);
      @include scroll-bar();
      overflow-y: scroll;
      overflow-x: hidden;

      p {
        height: 40px;
        line-height: 40px;
        font-size: 16px;
        font-weight: bold;
        white-space: pre-wrap;
        margin: 0 !important;
        padding: 0 !important;
      }

      span {
        display: table;
        padding: 0 10px;
        height: 30px;
        line-height: 30px;
      }

      div span:nth-child(1) {
        font-weight: bold;
      }

      div span:nth-child(2) {
        text-indent: 20px;
      }
    }

    .user-info-body-solt-no-receive-verify-code-footer {
      display: flex;
      justify-content: center;
      text-align: center;
      margin-top: 10px;
    }
  }

  .lw-y-edit-garden-body-solt {
    height: 100%;
    margin-top: 100px;
    display: flex;
    justify-content: center;
    height: 40px;
    line-height: 40px;

    .lw-y-edit-garden-body-solt-title {
      width: 80px;
      padding-right: 10px;
      text-align: right;
    }

    .lw-y-edit-garden-body-solt-select {
      .el-select {
        width: 300px;
      }
    }
  }

  .lw-y-edit-garden-footer-solt {
    display: flex;
    justify-content: center;

    ::v-deep .lw-button {
      width: 120px;
    }
  }
}
</style>
<style lang="scss" scoped>
@import "../../assets/scss/index";

.garden-success {
  top: 15vh !important;
}

.el-dropdown-select-option {
  position: absolute;
  top: computer(50px) !important;
  width: computer(150px);
  /*height: 130px; */
  background-color: #ffffff;
  box-shadow: 0 computer(8px) computer(12px) 0 rgba(7, 0, 2, 0.3);
  border-radius: computer(6px);
  border: solid 1px #dddddd;

  .popper__arrow {
    /*display: none;*/
  }

  .iconfont {
    font-size: computer(20px);
  }

  li {
    display: flex;
    /*justify-content: space-around;*/
    height: computer(40px);
    line-height: computer(40px);
    font-size: computer(16px);
    color: #333333;

    i {
      margin-right: computer(8px);
    }
  }

  li:hover {
    color: $color_main  !important;
  }
}
</style>
